module.exports = __webpack_public_path__ + "img/t3.c427d704.jpg";